import { Directive, ElementRef, Renderer, Input, OnChanges } from '@angular/core';
import { appService } from '../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../_services/common.service';
import { DecryptPipe } from '../auth/_services/encrypt-decrypt.pipe';

@Directive({
    selector: '[appHasRight]'
})
export class HasRightDirective {
    RoleRightsData: any = [];
    FlagDataReceived: any = false;

    @Input() appHasRight: string;
    @Input() ScreenCode: string;

    @Input() RightsList: string;
    SubModuleList: any = [];
    constructor(
        private el: ElementRef,
        private renderer: Renderer,
        private _appService: appService,
        private toastr: ToastrService,
        private cookieService: CookieService,
        private _commonService: CommonService,
        private decryptpipe: DecryptPipe
    ) {

    }

    async ngOnInit() {

        let UserRole = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
        if (UserRole.match('Admin')) {
            return true;
        }
        this.RoleRightsData = JSON.parse(localStorage.getItem('rights_assigned'));
        var flag: any = Boolean;

        if (this.RoleRightsData == null)
            await this.delay(200);

        if (this.ScreenCode == "null") {
            this.RightsList;
            if (this.RightsList != null && this.RightsList != undefined) {
                this.SubModuleList = JSON.parse(this.RightsList)
                var Chkflag = false;
                this.SubModuleList.forEach(element => {
                    flag = this._commonService.CheckHasRight(element.rightcode, element.screencode);
                    if (flag == true) {
                        Chkflag = true;
                    }
                });
                if (Chkflag == false) {
                    this.renderer.setElementStyle(this.el.nativeElement, 'display', 'none');
                }
            }
        }
        else {
            flag = this._commonService.CheckHasRight(this.appHasRight, this.ScreenCode);
            if (flag == false) {
                this.renderer.setElementStyle(this.el.nativeElement, 'display', 'none');
            }
        }
    }


    async delay(ms: number) {
        await new Promise(resolve => setTimeout(() => resolve(""), ms)).then(() => console.log("fired"));
    }

}
